<template>
  <v-container id="cartOverview" fluid class="pa-0">
    <CategoryBanner />

    <!-- Empty cart view -->
    <v-card v-if="!isResultCardShown" flat tile class="overview-container py-0">
      <v-row align="center" no-gutters class="mt-5">
        <v-col cols="12" md="6" class="d-flex justify-md-start justify-center">
          <div class="heading-h3">Shopping Cart</div>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" v-if="showEmptyCartSection" no-gutters class="mb-16">
        <v-col cols="12" md="12" class="text-center text-md-left py-6">
          <div class="body-heading-small">Your cart is currently empty.</div>
        </v-col>
        <v-col cols="12" md="12" class="text-center text-md-left">
          <v-btn
            color="secondary"
            :to="{
              name: 'Catalog',
            }"
            >Continue Shopping</v-btn
          >
        </v-col>
      </v-row>

      <!-- Not empty cart view -->
      <v-item-group v-else>
        <v-row no-gutters class="mt-7 mb-16">
          <!-- Cart items -->
          <v-col cols="12" md="6" class="pr-md-16">
            <v-row>
              <v-col v-for="item in items" :key="item.id" cols="12" md="12">
                <v-item>
                  <CartListItem :item="item" />
                </v-item>
              </v-col>
            </v-row>
          </v-col>

          <!-- Order summary -->
          <v-col cols="12" md="6" class="pl-md-16">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <v-card v-if="items.length > 0" class="text-md-start text-center pa-6">
                  <v-card-title class="body-heading-medium d-flex justify-md-start justify-center font-weight-bold">Order Summary</v-card-title>
                  <v-card-text>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-row no-gutters>
                            <v-col cols="12" md="6">Order Item(s):</v-col>
                            <v-col cols="12" md="6">{{ totalCartItemQuantity }}</v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-row no-gutters>
                            <v-col cols="12" md="6">Order Total: </v-col>
                            <v-col cols="12" md="6" class="secondary--text font-weight-bold">{{ `POINTS ${totalCartItemPoints}` }}</v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="12" class="mt-6">
                <v-btn block color="secondary" @click="submitGiftRedemptionRequest">Checkout</v-btn>
              </v-col>
              <v-col cols="12" md="12" class="mt-6">
                <v-btn block color="secondary" outlined :to="{ name: 'Catalog' }">Continue Shopping</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-item-group>
    </v-card>
    <div v-else class="overview-container">
      <ResultCard :success="isRequestSuccess" :successMsgTitle="requestSuccessMsgTitle" :successMsgSubtitle="requestSuccessMsgSubtitle" :successActions="requestSuccessActions" />
    </div>
    <WishListSection />
  </v-container>
</template>

<script>
  import CartListItem from "./CartListItem";
  import WishListSection from "@/components/WishList/WishListSection";
  import ResultCard from "@/components/ResultCard";
  import ProductSearchBar from "@/components/Catalog/ProductSearchBar";
  import CategoryBanner from "@/components/Catalog/CategoryBanner";

  export default {
    name: "CartOverview",

    data() {
      return {
        items: [],
        isResultCardShown: false,
        isRequestSuccess: false,
        requestSuccessMsgTitle: undefined,
        requestSuccessMsgSubtitle: undefined,
        requestSuccessActions: [
          {
            name: "View My Gifts",
            event: this.goToMyGifts,
          },
          {
            name: "Continue Shopping",
            event: this.goToCatalog,
          },
        ],
      };
    },

    methods: {
      toggleResultCard() {
        this.isResultCardShown = !this.isResultCardShown;
      },

      goToMyGifts() {
        if (this.$route.name !== "MyGifts") {
          this.$router.push({ name: "MyGifts" });
        }
      },

      goToCatalog() {
        if (this.$route.name !== "Catalog") {
          this.$router.push({ name: "Catalog" });
        }
      },

      submitGiftRedemptionRequest() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .post("/orders")
          .then((response) => {
            if (response && response.data) {
              this.submitGiftRedemptionRequestSuccess();
            } else {
              this.submitGiftRedemptionRequestFail();
            }

            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);

            this.submitGiftRedemptionRequestFail(error);
          });
      },

      submitGiftRedemptionRequestSuccess() {
        this.isRequestSuccess = true;

        this.isResultCardShown = true;
        this.requestSuccessMsgTitle = "Thank You!";
        this.requestSuccessMsgSubtitle = "Your order request has been sent to your parents.";
        this.$store.commit("setLoadingStatus", false);
      },

      submitGiftRedemptionRequestFail(error) {
        this.isRequestSuccess = false;

        this.$store.commit("setError", {
          message: this.$formatter.getErrorMsg(error),
          type: "error",
        });
        this.$store.commit("setLoadingStatus", false);
      },

      fetchCartItems() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .get("/cart")
          .then((response) => {
            if (response && response.data && response.data.cart) {
              this.items = response.data.cart;
            } else {
              this.$store.commit("setError", {
                message: this.$formatter.getErrorMsg(),
                type: "error",
              });
            }

            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: this.$formatter.getErrorMsg(error),
              type: "error",
            });
            this.$store.commit("setLoadingStatus", false);
          });
      },
    },

    components: { CartListItem, WishListSection, ResultCard, ProductSearchBar, CategoryBanner },

    computed: {
      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },

      userId() {
        return this.$route.params.id ? this.$route.params.id : this.$store.getters.userInfo.id;
      },

      showEmptyCartSection() {
        if (this.items.length > 0) {
          return false;
        }
        return true;
      },

      totalCartItemQuantity() {
        return this.items.length;
      },

      totalCartItemPoints() {
        let totalPoints = 0;

        this.items.forEach((item) => {
          totalPoints = totalPoints + item.product.points;
        });
        return totalPoints;
      },
    },

    created() {
      this.fetchCartItems();
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Cart/CartOverview.vue